

const makeFilesByType = (files) =>  {
  const filesByType = {}

  for (const file of files) {
    const name = file.name
    const ext = name.substring(name.lastIndexOf(".") + 1)

    filesByType[ext] = file
  }

  return filesByType
}

const makeFilesByName = (files)  => {
  const filesByName = {}
  for (const file of files) {
    const name = file.name
    const woExtension = name.substring(0, name.lastIndexOf("."))

    let arr = filesByName[woExtension]
    if (!arr) {
      arr = []
      filesByName[woExtension] = arr
    }
    arr.push(file)
  }

  const filesByType = {}
  for (const filename in filesByName) {
    if (!filesByName.hasOwnProperty(filename)) {
      continue
    }

    const files = filesByName[filename]
    filesByType[filename] = makeFilesByType(files)
  }

  return filesByType
}

export {
  makeFilesByType,
  makeFilesByName,
}


// WEBPACK FOOTER //
// ./src/components/Inputs/utils.js